<template>
    <div class="platform">
        <div v-if="campaign" class="d-flex justify-content-center align-items-center flex-column">
            <a 
                :href="campaign.project_url" 
                @click="fireEvent"
                target="_blank"
                class="expanded-row-ks-icon">
                <Icon :icon="campaign.platform"/>
            </a>
            <p data-name="backers">{{campaign.backers}}</p>
            <p>Backers</p>
        </div>
        <Loader style="width: 100%" v-if="loading"/>
        <span class="p-3 text-center warning c5" v-if="!campaign && !loading">Something went wrong</span>
    </div>
</template>

<script>
import { usePlatform, useRouter } from '../../../../../../core/hooks'
import Icon from '@/components/Theme/Icon'
import { watch } from '@vue/composition-api'
import { Loader } from '../../../../../../components/Icons'
export default {
    name: 'Platform',
    props: {
        campaignId: String,
        request: Object
    },
    components: {
        Icon,
        Loader
    },
    setup(props, context){
        const {campaign, loading} = usePlatform(props.campaignId, props.request.platformData);
        const {route} = useRouter()

        watch(campaign, (campaign) => {
            if(campaign) {
                context.emit('setRequestData', props.request.id, {
                    key: 'platformData',
                    value: campaign
                })
            }
        })

        const fireEvent = () => {
            context.root.$ga.event('Campaign', 'KS Icon Click', `
                Location: Dashboard Requests Expanded Row,
                Campaign: ${campaign.value.title}
            `)
            context.root.$sendMixpanelEvent('KS Icon Clicked', {
                'KS Icon Location': 'Dashboard Requests Expanded Row',
                'Viewed Campaign': campaign.value.title
            })
        }

        return {
            campaign,
            loading,
            fireEvent
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/scss/variables.scss';
div.platform {
    width: 134px;
    height: 134px;
    background: $c14;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 1px 2px rgba(8, 35, 48, 0.02), 0px 2px 12px rgba(8, 35, 48, 0.08), 0px -1px 2px rgba(8, 35, 48, 0.02);
    border-radius: 8px;
    p {
        color: $c3;
        font-size: $p4;
        &[data-name="backers"] {
            color: $c6;
            font-size: $p2;
            font-weight: $weight_bold;
            margin-top: 8px;
        }
    }
}
</style>